import React from "react";
import {
  Container,
  Title,
  Text,
  Button,
  Stack,
  Group,
  Paper,
} from "@mantine/core";
import {
  IconHome,
  IconArrowLeft,
  IconAlertCircle,
  IconMoodSad,
} from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-teal-50 to-cyan-50 flex items-center justify-center p-4">
      <Container size="md">
        <Paper
          p="xl"
          radius="lg"
          withBorder
          className="bg-white shadow-2xl"
        >
          <Stack gap="xl" align="center" className="text-center">
            {/* Animated 404 */}
            <div className="relative">
              <div className="text-9xl font-bold bg-gradient-to-r from-teal-600 via-cyan-600 to-teal-600 bg-clip-text text-transparent animate-pulse">
                404
              </div>
              <div className="absolute -top-4 -right-4">
                <IconMoodSad
                  size={64}
                  className="text-teal-400 animate-bounce"
                />
              </div>
            </div>

            {/* Icon */}
            <div className="w-24 h-24 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-full flex items-center justify-center shadow-lg">
              <IconAlertCircle size={48} className="text-white" />
            </div>

            {/* Title */}
            <div>
              <Title
                order={1}
                className="text-4xl md:text-5xl font-bold text-gray-800 mb-4"
              >
                Page Not Found
              </Title>
              <Text size="lg" className="text-gray-600 max-w-md">
                Oops! The page you're looking for doesn't exist or has been moved.
                Let's get you back on track.
              </Text>
            </div>

            {/* Actions */}
            <Group gap="md" mt="xl">
              <Button
                size="lg"
                leftSection={<IconHome size={20} />}
                onClick={() => navigate("/d")}
                className="bg-gradient-to-r from-teal-600 to-cyan-600 hover:from-teal-700 hover:to-cyan-700"
              >
                Go to Dashboard
              </Button>
              <Button
                size="lg"
                variant="outline"
                leftSection={<IconArrowLeft size={20} />}
                onClick={() => navigate(-1)}
                className="border-teal-600 text-teal-600 hover:bg-teal-50"
              >
                Go Back
              </Button>
            </Group>

            {/* Helpful Links */}
            <div className="mt-8 pt-8 border-t border-gray-200 w-full">
              <Text size="sm" className="text-gray-500 mb-4">
                Quick Links:
              </Text>
              <Group gap="md" justify="center">
                <Button
                  variant="subtle"
                  size="sm"
                  onClick={() => navigate("/d/patients")}
                  className="text-teal-600"
                >
                  Patients
                </Button>
                <Button
                  variant="subtle"
                  size="sm"
                  onClick={() => navigate("/d/bookings")}
                  className="text-teal-600"
                >
                  Bookings
                </Button>
                <Button
                  variant="subtle"
                  size="sm"
                  onClick={() => navigate("/d/consultations")}
                  className="text-teal-600"
                >
                  Consultations
                </Button>
                <Button
                  variant="subtle"
                  size="sm"
                  onClick={() => navigate("/d/transactions")}
                  className="text-teal-600"
                >
                  Transactions
                </Button>
              </Group>
            </div>
          </Stack>
        </Paper>
      </Container>
    </div>
  );
};

export default NotFound;


